import { EFeatureFlags } from 'constants/features';
import { IModalOptions } from 'modules/modals/types';
import AddTDPDialog from 'pages/tdp/modals/addTdp';
import clsx from 'clsx';
import { NewThreadButton } from './NewThreadButton';

interface IHeaderButtonProps {
  open: (options: IModalOptions) => void;
  features: Record<EFeatureFlags, boolean>;
  className?: string;
}

export const HeaderButton = ({ open, features, className }: IHeaderButtonProps) => {
  return (
    <div
      className={clsx(
        'flex w-full flex-row items-center justify-between gap-2 lg:w-auto',
        className
      )}
    >
      <NewThreadButton open={open} />
      {features['boeing-tdp'] && <AddTDPDialog />}
    </div>
  );
};
